import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import type { ComponentProps } from 'react';

import { AveragePlayerScore } from '@sorare/core/src/__generated__/globalTypes';
import { PlayerScore } from '@sorare/core/src/components/scoring/PlayerScore';

import { CardBonus } from '#src/components/card/CardBonus/index.tsx';
import { NBACardFooter } from '#src/components/card/NBACardFooter/index.tsx';

import type { NBAAnyCardFooter_anyCardInterface } from './__generated__/index.graphql.ts';

type Props = {
  anyCard: NBAAnyCardFooter_anyCardInterface;
} & Pick<ComponentProps<typeof CardBonus>, 'withTransferMalus'> &
  Pick<ComponentProps<typeof NBACardFooter>, 'extra' | 'onClick'>;

export const NBAAnyCardFooter = ({
  anyCard,
  withTransferMalus,
  ...footerProps
}: Props) => (
  <NBACardFooter
    anyPlayer={anyCard.anyPlayer}
    score={
      <PlayerScore
        player={anyCard.anyPlayer}
        mode={AveragePlayerScore.LAST_TEN_PLAYED_SO5_AVERAGE_SCORE}
        shape="TEXT"
        animated={false}
        hideTooltip
      />
    }
    bonus={<CardBonus card={anyCard} withTransferMalus={withTransferMalus} />}
    {...footerProps}
  />
);

NBAAnyCardFooter.fragments = {
  anyCardInterface: gql`
    fragment NBAAnyCardFooter_anyCardInterface on AnyCardInterface {
      slug
      anyPlayer {
        slug
        ...NBACardFooter_anyPlayerInterface
        ...PlayerScore_anyPlayer
      }
      ...CardBonus_anyCard
    }
    ${CardBonus.fragments.anyCard}
    ${NBACardFooter.fragments.anyPlayerInterface}
    ${PlayerScore.fragments.anyPlayer}
  ` as TypedDocumentNode<NBAAnyCardFooter_anyCardInterface>,
};
